import { Button, Paper, Typography, Box, Card, List } from "@mui/material";
import React, {useEffect, useState,useRef,useContext,forwardRef} from 'react';
import CenterFocusStrongTwoToneIcon from '@mui/icons-material/CenterFocusStrongTwoTone';
 
import {
    Animated,
    View,
    Text,
    StyleSheet,
    Dimensions,
    ScrollView,
    Platform,
    useWindowDimensions,
    Image,
    FlatList,
    Modal,
    TouchableOpacity,
    Pressable,
    Alert
  } from 'react-native';

  interface IPayload {
    messageValue: string;
    recipientsValue: string;
    choicesValue: string;
    workflowValue: string;
    priorityValue: string;
    soundtypeValue: string;
   
  }
 
  const Preview =(props:any)=>{
    const [modalVisible, setModalVisible] = useState(false);
    const [msgdata, setMsgData]=useState([]);
    const [msgType, setMsgType]=useState("");
     
    
    useEffect(()=>{
    // console.log("props.data:",props.data,msgdata);
        if(msgdata && modalVisible===true){
            setMsgData(props.data);
            setMsgType(props.messageType);
        }
        

    },[props.data,msgdata,modalVisible]);
    return(
        <View style={styles.centeredView}>
      <Modal
        animationType="fade"
        transparent={true}
        visible={modalVisible}
        onRequestClose={() => {
          //Alert.alert("Modal has been closed.");
          setModalVisible(!modalVisible);
        }}
      >
        <View style={styles.centeredView}>
          <View style={styles.modalView}>
              
          {<Card sx={{ minHeight: 400, maxHeight:480, overflow: 'auto', width:320,marginTop:2 }}>
            <View style={{justifyContent:'center', padding:5}}>
                <Text style={{fontWeight:'bold'}}>{msgType}</Text>
              { msgdata && msgdata.map((item,i) => <Text key={i} style={{fontSize:11, marginLeft:5}}>{item}</Text>)}
              </View>
    </Card>}
       
            <Pressable
              style={[styles.buttonClose]}
              onPress={() => setModalVisible(!modalVisible)}
            >
              <Text style={styles.textCloseStyle}>Close</Text>
            </Pressable>
          </View>
        </View>
      </Modal>
      <Pressable
        style={[ styles.buttonOpen]}
        onPress={() => setModalVisible(true)}
      >
         <CenterFocusStrongTwoToneIcon color="primary" style={{ fontSize: 40 }}/>
      </Pressable>

     
    </View>
    );
  };

const styles = StyleSheet.create({
    centeredView: {
      flex: 1,
      justifyContent: "center",
      alignItems: "center",
      
     
    },
    modalView: {
        position:'absolute',
      marginTop: "9%",
      marginLeft:'10%',
      margin: 20,
      backgroundColor: "white",
      borderRadius: 20,
      width:350,
      height:550,
      alignItems: "center",
      borderColor:'#08206c',
      borderWidth:5,
     
    },
    button: {
      borderRadius: 20,
      padding: 10,
      elevation: 2
    },
    buttonTitle:{
      backgroundColor:"#fff", 
      height:70,
      borderRadius:10,
      borderColor:'#1aaa56',
      borderWidth:4,
      width:150,
      justifyContent:'center',
    
    },
    buttonOpen: {
      backgroundColor:"#fff", 
      height:30,
      borderRadius:10,
      width:30,
      justifyContent:'center',
      marginTop:-10,
      marginLeft:120                      
    },
    buttonClose: {
      backgroundColor:"red", 
      height:30,
      borderRadius:10,
      justifyContent:'center',
      width:60,
      marginTop:505,
      marginLeft:250,
      position:'absolute',
       
    },
    textStyle: {
      color: "white",
      fontWeight: "bold",
      textAlign: "center",
      fontSize:12
      
    },
    textCloseStyle: {
      color: "white",
      fontWeight: "bold",
      textAlign: "center",
      fontSize:12
    },
    modalText: {
      marginTop:40,
      marginBottom: 15,
      textAlign: "left",
      lineHeight:35,
      fontSize:20
    }
  });
  export default Preview;